module.exports = __webpack_public_path__ + "img/已完成.401d054a.png";